import React, { useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
  RequiredTextInput,
  TextInput,
  TextAreaInput,
  MySelect,
  MyCheckbox,
} from "./FormikFormFunctions";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import { SpinnerCircularFixed } from "spinners-react";

const rebuildData = (data) => {
  let formData = new FormData();
  if (data.uploadedDocs)
    for (let i = 0; i < data.uploadedDocs.length; i++) {
      formData.append("Attachments", data["uploadedDocs"][i]);
    }

  if (data.companyLogo) formData.append("Logo", data["companyLogo"]);

  delete data.uploadedDocs;
  delete data.companyLogo;

  formData.append("Data", JSON.stringify(data));

  // for (var pair of formData.entries()) {
  //   console.log(pair[0] + "-----" + pair[1]);
  // }

  return formData;
};

const FormikSDCForm = () => {
  const logoRef = React.useRef();
  const docsRef = React.useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // function resetLogo() {
  //   if (logoRef.current.value) logoRef.current.value = "";
  // }
  // function resetDocs() {
  //   if (docsRef.current.value) docsRef.current.value = "";
  // }

  const getCurrentDate = (separator = "-") => {
    let newDate = new Date();
    let date_raw = newDate.getDate();
    let month_raw = newDate.getMonth() + 1;
    let year = newDate.getFullYear();
    var date, month;

    if (date_raw < 10) {
      date = "0" + date_raw.toString();
    } else {
      date = date_raw.toString();
    }
    if (month_raw < 10) {
      month = "0" + month_raw.toString();
    } else {
      month = month_raw.toString();
    }

    return `${year}${separator}${month}${separator}${date}`;
  };

  return (
    <>
      {/* THIS IS THE START OF THE PAGE MODAL SECTION */}
      <div
        className="modal modal-page fade"
        id="SDCForm"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="pageModalLabel"
        data-animation="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      data-keyboard="true"
                      aria-label="Close"
                    ></button>
                    <h2 style={{ fontWeight: "bold" }} id="pageModalLabel">
                      @one Alliance Design Competency Form
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <h4>
                      This form is required to be completed by any company
                      wishing to undertake ANY design work on behalf of the @one
                      Alliance (excluding temporary works design).
                    </h4>
                    <h4>
                      Your submission will be reviewed by the @one design team
                      and, if acceptable, added to the Design Competency
                      register.
                    </h4>
                    <h4>
                      You can nominate your company for specialist design
                      competency in the following categories:
                    </h4>
                    <h4>1. Civil</h4>
                    <h4>2. Underground pipeline </h4>
                    <h4>3. Mechanical </h4>
                    <h4>4. Electrical</h4>
                    <h4>5. Package plant and equipment</h4>
                    <h4>
                      There is an opportunity to nominate additional specialist
                      activities if required.
                    </h4>
                    <h4>
                      For any design work subcontracted out, the design
                      subcontractor must also submit their own competency form
                      and be listed on the design competency register.
                    </h4>
                    <hr
                      style={{
                        color: "#6d7a80",
                        backgroundColor: "#6d7a80",
                        height: 2,
                        borderColor: "#6d7a80",
                      }}
                    ></hr>
                    {/* THIS IS WHERE THE FORM STARTS */}
                    <Formik
                      //This is the default values setting up
                      initialValues={{
                        companyName: "",
                        companyNumber: "",
                        companyAddress: "",
                        companyPhone: "",
                        companyEmail: "",
                        hasOtherCompanyNames: "",
                        companyLogo: null,
                        otherCompanyNames: "",
                        competentCivilElements: [],
                        otherCivilElements: "",
                        competentUndergroundPipeline: [],
                        otherUndergroundPipeline: "",
                        competentMechanicalSystems: [],
                        otherMechanicalSystems: "",
                        competentElectricalSystems: [],
                        otherElectricalSystems: "",
                        competentPackageSystems: [],
                        otherPackageSystems: "",
                        hasDesignProcedure: "",
                        coveredByDesignProcedure: [],
                        hasProvenTrackRecord: "",
                        uploadedDocs: null,
                        whereProvenTrackRecord: "",
                        supportedBy: "",
                        BIM360ProcedureAdherence: "",
                        FurtherDetails: "",
                        name: "",
                        date: getCurrentDate(),
                      }}
                      //This is the validation const to determine which field require validation and what each criteria is.
                      validationSchema={Yup.object({
                        companyName: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                        companyNumber: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                        companyAddress: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                        companyPhone: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                        companyEmail: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                        hasOtherCompanyNames: Yup.string().required(
                          'Please select either "Yes" or "No"'
                        ),
                        hasDesignProcedure: Yup.string().required(
                          'Please select either "Yes" or "No"'
                        ),
                        hasProvenTrackRecord: Yup.string().required(
                          'Please select either "Yes" or "No"'
                        ),
                        BIM360ProcedureAdherence: Yup.string().required(
                          'Please select either "Yes" or "No"'
                        ),
                        name: Yup.string().required(
                          "Please enter an answer in this field"
                        ),
                      })}
                      ///////this is where we do the POST request of all the answers///////

                      //This is the onSubmit using axios sending to PV backend API
                      onSubmit={(values) => {
                        const data = rebuildData(values);
                        setIsSubmitting(true);
                        setTimeout(() => {
                          axios({
                            method: "post",
                            url: HOST_URL + `/api/savesdcdata`,
                            data: data,
                            headers: {
                              "Content-Type": "multipart/form-data",
                            },
                          })
                            .then((response) => {
                              alert(
                                "Thank you your form has been submitted. We will now process your application and will contact you in due course"
                              );
                              window.location = "/supplier";
                              // setSubmitting(false);
                              // resetForm();
                              // resetLogo();
                              // resetDocs();
                              setIsSubmitting(false);
                            })
                            .catch((error) => {
                              console.log(error);
                              alert(
                                "There was an error submitting your form, please try again."
                              );
                              setIsSubmitting(false);
                            });
                        }, 3000);
                      }}

                      // This is the onSubmit that shows output as a console log
                      // onSubmit={(values, { setSubmitting, resetForm }) => {
                      //   const data = rebuildData(values);
                      //   setTimeout(() => {
                      //     // console.log(
                      //     //   "stringified =",
                      //     //   JSON.stringify(values, null, 2)
                      //     // );
                      //     setSubmitting(false);
                      //   }, 400);
                      //   resetForm();
                      // }}
                    >
                      {({ values, setFieldValue }) => {
                        // prettier-ignore
                        return (
                          <Form>
                            <fieldset>
                              <h3 className="lead">Section 1</h3>
                              <RequiredTextInput
                                label="What is your company name?"
                                name="companyName"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <RequiredTextInput
                                label="What is your registered company number?"
                                name="companyNumber"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <RequiredTextInput
                                label="What is your company address?"
                                name="companyAddress"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <RequiredTextInput
                                label="What is your company phone number?"
                                name="companyPhone"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <RequiredTextInput
                                label="What is your company e-mail?"
                                name="companyEmail"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <MySelect
                                label="Does your company trade under other names?"
                                name="hasOtherCompanyNames"
                              >
                                <option value="">
                                  Please select an option
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </MySelect>
                              {values.hasOtherCompanyNames === "Yes" ? (
                                <TextInput
                                  label="What other names does your company trade under?"
                                  name="otherCompanyNames"
                                  type="text"
                                  placeholder="Enter your answer"
                                />
                              ) : null}
                              <div className="form-group">
                                <label className="lead" htmlFor="companyLogo">
                                  Please upload company logo here
                                </label>
                                <input
                                  name="companyLogo"
                                  id="companyLogo"
                                  type="file"
                                  className="form-control"
                                  ref={logoRef}
                                  onChange={(event) => {
                                    setFieldValue(
                                      "companyLogo",
                                      event.currentTarget.files[0]
                                    );
                                  }}
                                ></input>
                              </div>
                              <hr
                                style={{
                                  color: "#6d7a80",
                                  backgroundColor: "#6d7a80",
                                  height: 2,
                                  borderColor: "#6d7a80",
                                }}
                              ></hr>

                              <h3 className="lead">Section 2</h3>
                              <h3>Areas of design competency</h3>
                              <h4>
                                In this section you can nominate your areas of
                                design competency. Please work through each
                                section and tick all that apply and for which
                                you can demonstrate a proven track record.
                              </h4>
                              <MyCheckbox
                                title="What civil elements are you competent to design?"
                                name="competentCivilElements"
                              >
                                <div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Civil engineering design for typical structures in commonly used materials (e.g. concrete), including excavating, backfilling and restoration, building works and roadworks"
                                      id="q6c1"
                                    />
                                    <label htmlFor="q6c1">
                                      Civil engineering design for typical
                                      structures in commonly used materials
                                      (e.g. concrete), including excavating,
                                      backfilling and restoration, building
                                      works and roadworks
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Specialist design for marine structures including sea outfalls"
                                      id="q6c2"
                                    />
                                    <label htmlFor="q6c2">
                                      Specialist design for marine structures
                                      including sea outfalls
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Specialist design of submerged water retaining structures such as caisson shafts"
                                      id="q6c3"
                                    />
                                    <label htmlFor="q6c3">
                                      Specialist design of submerged water
                                      retaining structures such as caisson
                                      shafts
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Specialist engineering design of novel materials e.g. wood, plastics"
                                      id="q6c4"
                                    />
                                    <label htmlFor="q6c4">
                                      Specialist engineering design of novel
                                      materials e.g. wood, plastics
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Building design including architectural services"
                                      id="q6c5"
                                    />
                                    <label htmlFor="q6c5">
                                      Building design including architectural
                                      services
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentCivilElements"
                                      value="Piling System Design"
                                      id="q6c6"
                                    />
                                    <label htmlFor="q6c6">
                                      Piling System Design
                                    </label>
                                  </div>
                                </div>
                              </MyCheckbox>
                              <TextAreaInput
                                label="Please detail any other civil related specialist design activities in this section."
                                name="otherCivilElements"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <MyCheckbox
                                title="What underground pipeline systems are you
                              competent to design?"
                                name="competentUndergroundPipeline"
                              >
                                <div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Pipeline design of systems conveying water using typical materials in low pressure applications (up to 16 bar test pressure)"
                                      id="q8c1"
                                    />
                                    <label htmlFor="q8c1">
                                      Pipeline design of systems conveying water
                                      using typical materials in low pressure
                                      applications (up to 16 bar test pressure)
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Pipeline design of systems conveying wastewater using typical materials and with test pressures not exceeding 16 bar"
                                      id="q8c2"
                                    />
                                    <label htmlFor="q8c2">
                                      Pipeline design of systems conveying
                                      wastewater using typical materials and
                                      with test pressures not exceeding 16 bar
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist pipeline design involving pressures exceeding 16 bar test pressure (Water)"
                                      id="q8c3"
                                    />
                                    <label htmlFor="q8c3">
                                      Specialist pipeline design involving
                                      pressures exceeding 16 bar test pressure
                                      (Water)
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist pipeline design involving pressures exceeding 16 bar test pressure (Waste water)"
                                      id="q8c4"
                                    />
                                    <label htmlFor="q8c4">
                                      Specialist pipeline design involving
                                      pressures exceeding 16 bar test pressure
                                      (Waste water)
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist pipeline design using novel materials"
                                      id="q8c5"
                                    />
                                    <label htmlFor="q8c5">
                                      Specialist pipeline design using novel
                                      materials
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist design work involving directional drilling"
                                      id="q8c6"
                                    />
                                    <label htmlFor="q8c6">
                                      Specialist design work involving
                                      directional drilling
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist tunnelling design and associated works"
                                      id="q8c7"
                                    />
                                    <label htmlFor="q8c7">
                                      Specialist tunnelling design and
                                      associated works
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist pipeline design involving sludges in excess of 2% dry solids"
                                      id="q8c8"
                                    />
                                    <label htmlFor="q8c8">
                                      Specialist pipeline design involving
                                      sludges in excess of 2% dry solids
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentUndergroundPipeline"
                                      value="Specialist design of surge systems"
                                      id="q8c9"
                                    />
                                    <label htmlFor="q8c9">
                                      Specialist design of surge systems
                                    </label>
                                  </div>
                                </div>
                              </MyCheckbox>
                              <TextAreaInput
                                label="Please detail any other underground pipeline
                            related specialist design activities in this
                            section"
                                name="otherUndergroundPipeline"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <MyCheckbox
                                title="What mechanical systems are you competent to design?"
                                name="competentMechanicalSystems"
                              >
                                <div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="General mechanical design activities e.g. steel structures, packaged plant, above ground pipework systems not exceeding test pressures of 16 bar or sludge with not more than 2% dry solids"
                                      id="q10c1"
                                    />
                                    <label htmlFor="q10c1">
                                      General mechanical design activities e.g.
                                      steel structures, packaged plant, above
                                      ground pipework systems not exceeding test
                                      pressures of 16 bar or sludge with not
                                      more than 2% dry solids
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of mechanical equipment handling sludge"
                                      id="q10c2"
                                    />
                                    <label htmlFor="q10c2">
                                      Specialist design of mechanical equipment
                                      handling sludge
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of mechanical systems with test pressures exceeding 16 bar"
                                      id="q10c3"
                                    />
                                    <label htmlFor="q10c3">
                                      Specialist design of mechanical systems
                                      with test pressures exceeding 16 bar
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of chemical dosing systems"
                                      id="q10c4"
                                    />
                                    <label htmlFor="q10c4">
                                      Specialist design of chemical dosing
                                      systems
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of SEMD equipment"
                                      id="q10c5"
                                    />
                                    <label htmlFor="q10c5">
                                      Specialist design of SEMD equipment
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of equipment suitable for use in DSEAR environment"
                                      id="q10c6"
                                    />
                                    <label htmlFor="q10c6">
                                      Specialist design of equipment suitable
                                      for use in DSEAR environment
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of gas pipework and systems (e.g. digesters)"
                                      id="q10c7"
                                    />
                                    <label htmlFor="q10c7">
                                      Specialist design of gas pipework and
                                      systems (e.g. digesters)
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of pneumatic systems"
                                      id="q10c8"
                                    />
                                    <label htmlFor="q10c8">
                                      Specialist design of pneumatic systems
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of stainless steel vessels"
                                      id="q10c9"
                                    />
                                    <label htmlFor="q10c9">
                                      Specialist design of stainless steel
                                      vessels
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist structural steelwork design"
                                      id="q10c10"
                                    />
                                    <label htmlFor="q10c10">
                                      Specialist structural steelwork design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of diesel storage systems"
                                      id="q10c11"
                                    />
                                    <label htmlFor="q10c11">
                                      Specialist design of diesel storage
                                      systems
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of building services & HVAC systems incl. odour control ducting"
                                      id="q10c12"
                                    />
                                    <label htmlFor="q10c12">
                                      Specialist design of building services &
                                      HVAC systems incl. odour control ducting
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentMechanicalSystems"
                                      value="Specialist design of fire protection systems"
                                      id="q10c13"
                                    />
                                    <label htmlFor="q10c13">
                                      Specialist design of fire protection
                                      systems
                                    </label>
                                  </div>
                                </div>
                              </MyCheckbox>
                              <TextAreaInput
                                label="Please detail any other mechanical related
                            specialist design activities in this section"
                                name="otherMechanicalSystems"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <MyCheckbox
                                title="What electrical systems are you competent to design?"
                                name="competentElectricalSystems"
                              >
                                <div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="General electrical switchgear design"
                                      id="q12c1"
                                    />
                                    <label htmlFor="q12c1">
                                      General electrical switchgear design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Electrical installation design"
                                      id="q12c2"
                                    />
                                    <label htmlFor="q12c2">
                                      Electrical installation design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design of lightning protection systems"
                                      id="q12c3"
                                    />
                                    <label htmlFor="q12c3">
                                      Specialist design of lightning protection
                                      systems
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design of ATEX installations / DSEAR environments"
                                      id="q12c4"
                                    />
                                    <label htmlFor="q12c4">
                                      Specialist design of ATEX installations /
                                      DSEAR environments
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design of earthing systems"
                                      id="q12c5"
                                    />
                                    <label htmlFor="q12c5">
                                      Specialist design of earthing systems
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design involving telemetry"
                                      id="q12c6"
                                    />
                                    <label htmlFor="q12c6">
                                      Specialist design involving telemetry
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design of SEMD equipment"
                                      id="q12c7"
                                    />
                                    <label htmlFor="q12c7">
                                      Specialist design of SEMD equipment
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentElectricalSystems"
                                      value="Specialist design of HV systems"
                                      id="q12c8"
                                    />
                                    <label htmlFor="q12c8">
                                      Specialist design of HV systems
                                    </label>
                                  </div>
                                </div>
                              </MyCheckbox>
                              <TextAreaInput
                                label="Please detail any other electrical related
                            specialist design activities in this section"
                                name="otherElectricalSystems"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <MyCheckbox
                                title="What equipment supply / package systems are you competent to design?"
                                name="competentPackageSystems"
                              >
                                <div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Process package design"
                                      id="q14c1"
                                    />
                                    <label htmlFor="q14c1">
                                      Process package design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Mechanical package design"
                                      id="q14c2"
                                    />
                                    <label htmlFor="q14c2">
                                      Mechanical package design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Mechanical rotating equipment design"
                                      id="q14c3"
                                    />
                                    <label htmlFor="q14c3">
                                      Mechanical rotating equipment design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Generator equipment design"
                                      id="q14c4"
                                    />
                                    <label htmlFor="q14c4">
                                      Generator equipment design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Odour treatment package design"
                                      id="q14c5"
                                    />
                                    <label htmlFor="q14c5">
                                      Odour treatment package design
                                    </label>
                                  </div>
                                  <div className="check">
                                    <Field
                                      type="checkbox"
                                      name="competentPackageSystems"
                                      value="Other"
                                      id="q14c6"
                                    />
                                    <label htmlFor="q14c6">Other</label>
                                  </div>
                                </div>
                              </MyCheckbox>
                              <TextAreaInput
                                label="Please provide further detail on your
                            equipment supply / package design here"
                                name="otherPackageSystems"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <hr
                                style={{
                                  color: "#6d7a80",
                                  backgroundColor: "#6d7a80",
                                  height: 2,
                                  borderColor: "#6d7a80",
                                }}
                              ></hr>
                              <h3 className="lead">Section 3</h3>
                              <h3>Quality procedure and proven track record</h3>
                              <h4>
                                This section requests more detail on your
                                company quality procedures for design and track
                                record. Please note that if you cannot
                                demonstrate suitable design procedures or a
                                proven track record you will not be approved to
                                perform design activities on behalf of the @one
                                Alliance.
                              </h4>
                              <MySelect
                                label="Does your company have a design procedure that meets the requirements of the CDM 2015 regulations?"
                                name="hasDesignProcedure"
                              >
                                <option value="">
                                  Please select an option
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </MySelect>
                              {values.hasDesignProcedure === "Yes" ? (
                                <MyCheckbox
                                  title="Please select which of the following provisions are covered by your company design procedure"
                                  name="coveredByDesignProcedure"
                                >
                                  <div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value="A design competency assessment for all your design resources?"
                                        id="q17c1"
                                      />
                                      <label htmlFor="q17c1">
                                        A design competency assessment for all
                                        your design resources?
                                      </label>
                                    </div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value=" A checking and approving procedure by suitably qualified designers"
                                        id="q17c2"
                                      />
                                      <label htmlFor="q17c2">
                                         A checking and approving procedure by
                                        suitably qualified designers
                                      </label>
                                    </div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value="A procedure for reviewing third party design (note that your 3rd party designers should also complete this form)"
                                        id="q17c3"
                                      />
                                      <label htmlFor="q17c3">
                                        A procedure for reviewing third party
                                        design (note that your 3rd party
                                        designers should also complete this
                                        form)
                                      </label>
                                    </div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value="A procedure for effectively managing design changes"
                                        id="q17c4"
                                      />
                                      <label htmlFor="q17c4">
                                        A procedure for effectively managing
                                        design changes
                                      </label>
                                    </div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value="A procedure for engaging with the construction site team prior to delivery of your scope of supply"
                                        id="q17c5"
                                      />
                                      <label htmlFor="q17c5">
                                        A procedure for engaging with the
                                        construction site team prior to delivery
                                        of your scope of supply
                                      </label>
                                    </div>
                                    <div className="check">
                                      <Field
                                        type="checkbox"
                                        name="coveredByDesignProcedure"
                                        value="None of the above"
                                        id="q17c6"
                                      />
                                      <label htmlFor="q17c6">
                                        None of the above
                                      </label>
                                    </div>
                                  </div>
                                </MyCheckbox>
                              ) : null}

                              <MySelect
                                label="Do you have a proven track record of design activities selected in this application?"
                                name="hasProvenTrackRecord"
                              >
                                <option value="">
                                  Please select an option
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </MySelect>
                              {values.hasProvenTrackRecord === "Yes" ? (
                                <div className="form-group">
                                  <label
                                    className="lead"
                                    htmlFor="uploadedDocs"
                                  >
                                    Please upload all relevant supporting
                                    documentation here - please hold Ctrl and
                                    click to select multiple files
                                  </label>
                                  <input
                                    name="uploadedDocs"
                                    id="uploadedDocs"
                                    type="file"
                                    className="form-control"
                                    onChange={(event) => {
                                      setFieldValue(
                                        "uploadedDocs",
                                        event.currentTarget.files
                                      );
                                    }}
                                    ref={docsRef}
                                    multiple
                                  ></input>
                                </div>
                              ) : null}
                              <TextInput
                                label="Is your application supported by an @one Design Manager / Lead Technical Manager / Technical Manager or Lead Engineer? Please provide their name."
                                name="supportedBy"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <MySelect
                                label="Have you read the @one Engineering procedures for hosting design submissions on the BIM360 docs platform and do you agree to adhere to them?"
                                name="BIM360ProcedureAdherence"
                              >
                                <option value="">
                                  Please select an option
                                </option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </MySelect>
                              <TextAreaInput
                                label="Do you wish to add any further details to support your application?"
                                name="FurtherDetails"
                                type="textarea"
                                placeholder="Enter your answer"
                                rows="5"
                              />
                              <RequiredTextInput
                                label="What is your name?"
                                name="name"
                                type="text"
                                placeholder="Enter your answer"
                              />
                              <hr
                                style={{
                                  color: "#6d7a80",
                                  backgroundColor: "#6d7a80",
                                  height: 2,
                                  borderColor: "#6d7a80",
                                }}
                              ></hr>
                              <h4>
                                By submitting this form, you consent to the @one
                                Alliance Engineering Team including your
                                company’s contact details and details of your
                                design capabilities within the @one Alliance
                                Design Competency Register. Please do not
                                provide personal email addresses or personal
                                telephone numbers.
                              </h4>
                              <div className="form-group row">
                                <div className="col p-0 text-right">
                                  <div className="btn-group">
                                    <button
                                      type="button"
                                      className="btn btn-secondary"
                                      data-dismiss="modal"
                                      data-keyboard="true"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="submit"
                                      className="btn btn-primary"
                                    >
                                      <SpinnerCircularFixed
                                        size={20}
                                        thickness={180}
                                        speed={140}
                                        enabled={isSubmitting}
                                        color="rgba(0, 114, 188, 1)"
                                        secondaryColor="rgba(0, 0, 0, 0.92)"
                                      />
                                      {isSubmitting ? (
                                        <span>Submitting...</span>
                                      ) : (
                                        <span>Submit</span>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormikSDCForm;
